<template>
  <div></div>
</template>

<script>
import { Dialog } from "buefy/dist/components/dialog";
import { sendFeedback } from "../api-requests";

export default {
  name: "FeedbackModal",
  components: {},
  methods: {
    activateModal() {
      console.log("Activating the modal.");
      Dialog.prompt({
        message:
          "We really appreciate receiving feedback!<br/><br/>In case you expect to get response, please include your email address (as we do not store any).",
        inputAttrs: {
          placeholder: "Your message",
          maxlength: 10000,
          value: ""
        },
        onConfirm: async function(value) {
          await sendFeedback(value);
          console.log("Feedback sent.");
        },
        confirmText: "Send feedback"
      });
    }
  }
};
</script>
